module.exports = __webpack_public_path__ + "static/img/recommend-list-4.e37c5cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-4.png
// module id = Mn/n
// module chunks = 1